<button 
    type='button' 
    class='btn btn-sm btn-outline-danger noPrint' 
    (click)="resetFilterData()"
>
	Reset Filters
</button>
